import { registerPlugin } from '@capacitor/core';
import { withBridgedStackTrace } from '../withBridgedStackTrace';

import type { SignInWithAppleNativeAndroidPlugin } from './definitions';
import { CAPACITOR_SIGN_IN_WITH_APPLE_NATIVE_ANDROID_PLUGIN_NAME } from '../pluginConstants';

const SignInWithAppleNativeAndroidRaw = registerPlugin<SignInWithAppleNativeAndroidPlugin>(
    CAPACITOR_SIGN_IN_WITH_APPLE_NATIVE_ANDROID_PLUGIN_NAME,
);
const SignInWithAppleNativeAndroid = withBridgedStackTrace(
    SignInWithAppleNativeAndroidRaw,
    CAPACITOR_SIGN_IN_WITH_APPLE_NATIVE_ANDROID_PLUGIN_NAME,
);

export * from './definitions';
export { SignInWithAppleNativeAndroid };
